import * as React from 'react'
import { cn } from '@/lib/utils'

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, ...props }, ref) => {
    return React.createElement('span', {
      ref,
      className: cn('ui-badge', className),
      ...props,
    })
  }
)
Badge.displayName = 'Badge'
